<template>
  <div class="bet-type-selector">
    <div class="bet-type-selector__tabs">
      <div
        :class="['tab', (getBet.type === 'single' || getBet.type === 'multiple') ? 'tab--active' : '']"
        @click="changeType('multiple')"
      >
        <span v-if="getBet.type === 'single' && getSettings.single">{{ $t('single') }}</span>
        <span v-else>{{ $t('multiple') }}</span>
      </div>
      <div
        v-if="getSettings.integral"
        :class="['tab', getBet.type === 'integral' ? 'tab--active' : '']"
        @click="changeType('integral')"
      >{{ $t('integral') }}</div>
      <div
        v-if="getSettings.system"
        :class="[
          'tab',
          getBet.type === 'system' ? 'tab--active' : '',
          (getBet.type === 'integral' || getBet.type === 'single' || getBet.odds.length === 1 || getBet.odds.length > 10 || hasBetBuilder) ? 'tab--disabled' : ''
        ]"
        @click="changeType('system')"
      >{{ $t('system') }}</div>
    </div>

    <button class="bet-type-selector__clear" @click="clearAll">
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
        <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5"/>
      </svg>
      {{ $t('clear_all') }}
    </button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'BetTypeSelectorAmerican',
  computed: {
    ...mapGetters({
      getBet: 'cart/getBet',
      getSettings: 'cart/getSettings',
      hasBetBuilder: 'cart/hasBetBuilder',
    }),
  },
  methods: {
    ...mapActions({
      setBetType: 'cart/setBetType',
      refreshCart: 'cart/refreshCart',
      resetCart: 'cart/resetCart',
    }),
    async clearAll() {
      this.$root.$emit('cart_handling', true);
      await this.resetCart();
    },
    async changeType(type) {
      if (this.getBet.odds.length > 10 && type === 'system') return;
      if (this.getBet.type === 'integral' && type === 'system') return;
      if (this.getBet.type !== 'simple' && this.getBet.odds.length > 1) {
        await this.setBetType({ type });
        await this.refreshCart();
      }
    },
  },
};
</script>

<style scoped>
.bet-type-selector {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.bet-type-selector__tabs {
  display: flex;
  align-items: center;
}
.tab {
  font-size: var(--font-size-xl);
  font-weight: 400;
  text-transform: capitalize;
  padding: 10px 10px;
  cursor: pointer;
  color: var(--text-cart);
  border-bottom: 2px solid transparent;
  transition: color 0.15s, border-color 0.15s;
  white-space: nowrap;
  user-select: none;
}
.tab--active {
  color: var(--color-primary);
  border-bottom-color: var(--color-primary);
}
.tab--disabled {
  color: rgba(255,255,255,0.15);
  cursor: not-allowed;
  pointer-events: none;
}
.tab:not(.tab--disabled):not(.tab--active):hover {
  color: var(--text-platform);
}
.bet-type-selector__clear {
  display: flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: var(--font-size-xl);
  padding: 8px 10px;
  transition: color 0.15s;
  white-space: nowrap;
  user-select: none;
  color: var(--danger, #ef4444);

}

</style>
